import React from 'react';
import { BoxIcon } from 'lucide-react';
interface BonusCardProps {
  icon: BoxIcon;
  title: string;
  subtitle: string;
  description: string;
  quote: string;
  value: string;
}
export function BonusCard({
  icon: Icon,
  title,
  subtitle,
  description,
  quote,
  value
}: BonusCardProps) {
  return <div className="bg-white rounded-2xl p-8 shadow-soft-lg hover:shadow-soft-xl transition-all duration-300 border border-[#E8905C]/20" data-id="element-33">
      <div className="mb-4" data-id="element-34">
        <Icon className="w-12 h-12 text-[#1C2A3A]" strokeWidth={1.5} data-id="element-35" />
      </div>
      <h3 className="font-['Crimson_Text'] text-2xl font-semibold text-[#1C2A3A] mb-2" data-id="element-36">
        {title}
      </h3>
      <p className="text-sm text-[#1C2A3A] font-medium mb-4" data-id="element-37">{subtitle}</p>
      <p className="text-[#3E4A55] mb-4 leading-relaxed" data-id="element-38">{description}</p>
      <p className="text-[#1C2A3A] italic mb-4 pl-4 border-l-4 border-[#E8905C]" data-id="element-39">
        &quot;{quote}&quot;
      </p>
      <div className="flex items-center gap-2 text-[#1C2A3A] font-semibold" data-id="element-40">
        <Icon className="w-5 h-5" strokeWidth={2} data-id="element-41" />
        <span data-id="element-42">{value}</span>
      </div>
    </div>;
}